<template>
	<div class="three-headlines">
		<div class="headline-wrapper">
			<h1>
				12 MIO
			</h1>
			<h3>
				media impressions in two weeks
			</h3>
		</div>
		<div class="headline-wrapper">
			<h1>
				39 hrs
			</h1>
			<h3>
				sold out in 39 hrs
			</h3>
		</div>
		<div class="headline-wrapper">
			<h1>
				60%
			</h1>
			<h3>
				followed through on their purchase
			</h3>
		</div>
	</div>
</template>

<script>


	export default {
        name: 'three-headlines',
    }
</script>

<style lang="scss" scoped>
	.three-headlines {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		padding: 5%;



		@media screen and (min-width: 768px) {
			flex-wrap: nowrap;
		}
	}

	.headline-wrapper {
		flex-basis: 100%;
		text-align: center;
		padding: 6%;

		@media screen and (max-width: 1024px) {
			padding: 5% 0 5% 0;
		}

		@media screen and (max-width: 768px) {
			padding: 2% 0 2% 0;
		}

			h1 {
				text-transform: uppercase;
				font-family: dkms1;
				font-size: 5rem;
				letter-spacing: .7px;
				padding: 1%;
				margin-bottom: 0;

				@media screen and (max-width: 1024px) {
					font-size: 2.3rem;
					letter-spacing: 1px;
				}

				@media screen and (max-width: 768px) {
					font-size: 2.1rem;
					letter-spacing: 1px;
				}
			}


		h3 {
			font-size: 1.3rem;
			letter-spacing: .7px;
			color: #303030;
			margin-top: 0;

			@media screen and (max-width: 1024px) {
				font-size: 1.1rem;
			}

			@media screen and (max-width: 768px) {
				font-size: .9rem;
			}

		}

	}

</style>
